import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { SECURITY_API } from "./apiRoutes";

interface ResetUserPasswordPayload {
    data:any
}

const mutateResetUserPassword = async ({
  data,
}: ResetUserPasswordPayload) => {
  return axiosAuth.patch(
    `${SECURITY_API}/admin/reset-password`,
    data
  );
};

const useResetUserPasswordMutation = (
  options?: UseMutationOptions<
    any,
    Error,
    ResetUserPasswordPayload
  >
) => {
  return useMutation({
    mutationFn: mutateResetUserPassword,
    ...options,
  });
};

export default useResetUserPasswordMutation;